import { useEffect, useRef } from 'react';
import { Group } from 'three';

import { useDollhouse } from '@spazious/dollhouse-engine';

import { subscribeDragPreview } from '../core/dragPreview.js';

/**
 * Offsets a wrapper group with the live drag-preview movement. Selection
 * wrappers (RectControls, PolygonControls, ...) render from node positions,
 * which stay untouched until drop, so without this they lag behind the
 * visually dragged furniture.
 */
export const useDragPreviewOffset = (selector: string | null | undefined) => {
  const invalidate = useDollhouse(({ invalidate }) => invalidate);
  const groupRef = useRef<Group>(null);

  useEffect(
    () =>
      subscribeDragPreview((payload) => {
        const group = groupRef.current;
        if (!group) {
          return;
        }
        if (payload && selector && payload.selectors.has(selector)) {
          group.position.set(payload.movement.x, 0, payload.movement.z);
        } else {
          group.position.set(0, 0, 0);
        }
        invalidate();
      }),
    [selector, invalidate]
  );

  return groupRef;
};
